import React from 'react';
import BubbleNavigation from '../BubbleUI/BubbleNavigation';
import {
  resolveGroupPartiesPath,
  resolveGroupResourcesPath,
  resolveGroupsPath,
} from '@go-client/routes';
import { useActiveProperty } from '@go-client/context/ActivePropertyContext';

export default function GroupsNavigation(props: { active: 'bookings' | 'groups' | 'resources' }) {
  const { activeProperty } = useActiveProperty();

  return (
    <BubbleNavigation
      items={[
        {
          name: 'Groups',
          to: resolveGroupPartiesPath(activeProperty._id),
          active: props.active === 'groups',
          variant: 'forest',
        },
        {
          name: 'Group Bookings',
          to: resolveGroupsPath(activeProperty._id),
          active: props.active === 'bookings',
          variant: 'forest',
        },
        {
          name: 'Resources',
          to: resolveGroupResourcesPath(activeProperty._id),
          active: props.active === 'resources',
          variant: 'forest',
        },
      ]}
    />
  );
}
